/*
 * Hemen irakurria: https://www.robinwieruch.de/react-internationalization
 */
import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import Backend from 'i18next-http-backend'

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'en',
    debug: false,
    // itzulpen hutsak ez bueltatzeko
    returnEmptyString: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    react: {
      useSuspense: true,
    },
    detection: {
      // hizkuntza detektoreak begiratuko duen gakoa localStoragen (berak bakarrik ezartzen ditu balioak)
      lookupLocalStorage: 'i18nextLng',
    },
    interpolation: {
      format: (value, format, lng) => {
        if (format === 'intlCurrency') {
          const formatter = new Intl.NumberFormat(lng, {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
          })
          return formatter.format(value)
        }
        return value
      },
    },
    keySeparator: false,
  })

export default i18n
